import { useAppSelector } from '@/Hook/hooks';
import { getCompanyDetails, setCompanyDetails } from '@/Utils/auth';
import { ControlTranslation } from 'AlignComponents';
import React, { useEffect, useState } from 'react';
import { LuBuilding2 } from 'react-icons/lu';
import Select, { components } from 'react-select';

const customStyles = {
  container: (base: any) => ({
    ...base,
    width: '150px',
  }),
  control: (base: any) => ({
    ...base,
    border: "1px solid #cbcbcb",
    // This line disable the blue border
    // height: '42px',
    // borderRadius: '6px'
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #0ac3da',
    }
  }),
  valueContainer: (base: any) => ({
    ...base,
    fontSize: '11px',
    color: "#000",
    fontWeight: "bold"
  }),
  placeholder: (base: any) => ({
    ...base,
    fontSize: "9px",
    color: "#575757ab",
    fontWeight: "normal",
    position: "relative",
    top: "2px",
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  option: (base: any, state: any) => ({
    ...base,
    fontSize: '11px',
    backgroundColor: state.isSelected ? '#0ac3da' : 'inherit',
    '&:hover': {
      backgroundColor: state.isSelected ? '#0ac3da' : '#e7f9fb'
    }
  }),
}

const { ValueContainer, Placeholder, SingleValue } = components;

const CustomValueContainer = ({ children, ...props }: any) => {
  return (
    <ValueContainer {...props}>
      {React.Children.map(children, child =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const CustomSingleValue = (props: any) => {
  return (
    <SingleValue {...props}>
      <div style={{ display: "flex", whiteSpace: "nowrap", alignItems: "center", overflow: "hidden", gap: "10px" }}>
        <LuBuilding2 style={{ flexShrink: 0 }} size={20} />
        <div>
          <Placeholder {...props} isFocused={props.isFocused}>
            <ControlTranslation system={true} controlId="lblcompany" />
          </Placeholder>
          {props.data.label}
        </div>
      </div>
    </SingleValue>
  );
};

const CompanySelector = () => {
  const [options, setOptions] = useState<any>([]);
  const { userLegalEntity, selectedLegalEntity } = useAppSelector(state => ({
    userLegalEntity: state.User.UserLegalEntity,
    selectedLegalEntity: state.User.selectedLegalEntity,
  }));

  useEffect(() => {
    setOptions(userLegalEntity.map((x: any) => ({
      value: x.legalentityno,
      label: `${x.legalentitystxt} (${x.legalentityno})`
    })));

  }, [userLegalEntity])

  const changeLegalEntity = (option: any) => {
    const companyDetails = getCompanyDetails();
		setCompanyDetails({ timezone: companyDetails.timezone, selectedLegalEntity: option.value, selectedLang: companyDetails.selectedLang });
    location.reload();
  }

  return options.length >= 1 ? (
    <div>
      {
        selectedLegalEntity ? (
          <Select
            components={{ ValueContainer: CustomValueContainer, SingleValue: CustomSingleValue }}
            options={options}
            value={options.find((x: any) => x.value == selectedLegalEntity)}
            onChange={changeLegalEntity}
            styles={customStyles}
          />
        ) : null
      }
    </div>
  ) : null
}

export default CompanySelector;